import _ from 'underscore';
import { GetJsDataInfo } from '@bingads-webui-clientcenter/js-data-cc-rest-base';

const ccJsDataObj = {};
export function getCCJsDataObj(cid, uid, ccBaseUrl) {
  if (ccJsDataObj[cid]) {
    return ccJsDataObj[cid];
  }

  const { jsDataCcRest } = GetJsDataInfo({
    cidFetcher: _.constant(cid),
    uidFetcher: _.constant(uid),
  }, ccBaseUrl);
  ccJsDataObj[cid] = jsDataCcRest;
  return jsDataCcRest;
}
